import React from 'react';

/**
 * The ProgressBar component takes in an integer representing the percentage fill for a progress bar
 *  and two colors as strings for coloring the bar
 * @param { number } fill -> The fill percentage for the input.
 */
export default function ProgressBar({ fill = 0}) {

  return (
    <div className={"gc__progress-wrapper"}>
      <div className={"gc__progress-inner"} style={{ width: `${fill}%` }}>&nbsp;</div>
    </div>
  )
}

